import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeRumPublicApi, startRum } from '@datadog/browser-rum-core';
import { startRecording } from './startRecording';
import { makeRecorderApi } from './recorderApi';
var recorderApi = makeRecorderApi(startRecording);
export var datadogRum = makeRumPublicApi(startRum, recorderApi);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=rum.entry.js.map